import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M9.938 9.26 8.083 5.876A3.748 3.748 0 1 0 1.25 3.75a3.7 3.7 0 0 0 .667 2.126L.062 9.26A.5.5 0 0 0 .5 10a.4.4 0 0 0 .089-.008l2.75-.5a.5.5 0 0 0 .381-.322l.628-1.736A3.7 3.7 0 0 0 5 7.5a3.7 3.7 0 0 0 .652-.066L6.28 9.17a.5.5 0 0 0 .381.322l2.75.5A.4.4 0 0 0 9.5 10a.5.5 0 0 0 .438-.74M5 6a2.25 2.25 0 1 1 2.25-2.25A2.25 2.25 0 0 1 5 6"
    }, null, -1)
  ]));
}
const interfaceFavoriteAward = { render };
export {
  interfaceFavoriteAward as default,
  render
};
//# sourceMappingURL=interface-favorite-award.svg.js.map
